var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "MobileContainer",
    [
      _c(
        "MobileHeader",
        { attrs: { slot: "header", "nav-action": "close" }, slot: "header" },
        [_vm._v("\n    Select a Location\n  ")]
      ),
      _vm._v(" "),
      _c("RestaurantPicker", {
        attrs: { "next-route-name": _vm.nextRouteName }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/mobile/components/MobileSelectLocation.vue?vue&type=template&id=53af5313&
// module id = null
// module chunks = 